"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGiveaway200ResponseToJSON = exports.GetGiveaway200ResponseFromJSONTyped = exports.GetGiveaway200ResponseFromJSON = exports.instanceOfGetGiveaway200Response = void 0;
var runtime_1 = require("../runtime");
var Giveaway_1 = require("./Giveaway");
/**
 * Check if a given object implements the GetGiveaway200Response interface.
 */
function instanceOfGetGiveaway200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetGiveaway200Response = instanceOfGetGiveaway200Response;
function GetGiveaway200ResponseFromJSON(json) {
    return GetGiveaway200ResponseFromJSONTyped(json, false);
}
exports.GetGiveaway200ResponseFromJSON = GetGiveaway200ResponseFromJSON;
function GetGiveaway200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, Giveaway_1.GiveawayFromJSON)(json['data']),
    };
}
exports.GetGiveaway200ResponseFromJSONTyped = GetGiveaway200ResponseFromJSONTyped;
function GetGiveaway200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, Giveaway_1.GiveawayToJSON)(value.data),
    };
}
exports.GetGiveaway200ResponseToJSON = GetGiveaway200ResponseToJSON;
